import Splide from "@splidejs/splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";

export default function Sliders() {
	// --- Banner Slider ---
	const bannerElements = document.querySelector(".js-banner-slider");
	bannerElements &&
		new Splide(".js-banner-slider", {
			type: "loop", // Allows infinite looping of slides
			easing: "cubic-bezier(.77,0,.175,1)", // Custom easing
			speed: 500, // Customer Animation Time
			arrows: true, // Display navigation arrows
			pagination: false, // Hide pagination dots
			keyboard: false, // Disable keyboard navigation
			drag: true, // Enable slide dragging with mouse
			snap: true, // Force move to the closest slide on drag end
			perPage: 2, // 2 page per slide
			perMove: 1, // 1 page per slide
			gap: 40, // Add a 40px gap
			// autoplay: {
			// 	// speed: 1000,
			// },
		}).mount();

	// --- Testimonials Slider ---
	const testimonailsElements = document.querySelector(".js-testimonials");
	testimonailsElements &&
		new Splide(".js-testimonials", {
			type: "loop", // Allows infinite looping of slides
			easing: "cubic-bezier(.77,0,.175,1)", // Custom easing
			speed: 500, // Customer Animation Time
			arrows: true, // Display navigation arrows
			pagination: false, // Hide pagination dots
			keyboard: false, // Disable keyboard navigation
			drag: true, // Enable slide dragging with mouse
			snap: true, // Force move to the closest slide on drag end
			perPage: 1, // 3 page per slide
			perMove: 1, // 1 page per slide
			gap: 20, // Add a 20px gap
			mediaQuery: "min", // Use min widths to calculate the breakpoints
			breakpoints: {
				767: {
					perPage: 2, // Load 4 slides for iPad and up
				},
				1023: {
					gap: 40, // Add a 40px gap
					perPage: 3, // Load 6 slides for iPad pro and up
				},
			},
		}).mount();

	const logoSlider = document.querySelector(".js-logo-slider");
	logoSlider &&
		new Splide(".js-logo-slider", {
			type: "loop",
			gap: 40,
			pagination: false,
			arrows: false,
			mediaQuery: "min",
			drag: "free",
			focus: "center",
			perPage: 3,
			autoScroll: {
				speed: 0.5,
			},
			breakpoints: {
				1023: {
					gap: 60,
					perPage: 4,
				},
				1279: {
					perPage: 5,
				},
			},
		}).mount({ AutoScroll });
}
